<template>
  <a-form
    :form="form"
    class="quit-select-form"
    layout="inline"
    hide-required-mark
    @submit="handleSubmit"
  >
    <a-form-item
      :label="`${quitTitTxt}：`"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 12 }"
    >
      <a-select
        v-decorator="[
          'userid',
          {rules: [{ required: true, message: 'selectSearchPlace' }]}
        ]"
        show-search
        :placeholder="selectSearchPlace"
        option-filter-prop="children"
        :filter-option="filterOption"
        @change="handleSelectChange"
      >
        <a-select-option
          v-for="item in personsList"
          :key="item.userid"
          :value="item.userid"
        >
          {{ item.truename }}
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item
      :wrapper-col="{ span: 12, offset: 5 }"
    >
      <a-button
        type="primary"
        :disabled="!isSelected || isSubmiting"
        html-type="submit"
      >
        {{ $t('message["91"]') }}
      </a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
export default {
  props: {
    userid: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isSelected: false,
      form: this.$form.createForm(this),
      isSubmiting: false
    }
  },
  computed: {
    ...mapState('quit', ['personsList', 'quitName']),
    ...mapGetters('quit', ['dataList']),
    truname () {
      return this.$route.query.truename
    },
    type () {
      return this.$route.query.type
    },
    quitTitTxt () {
      return this.$t('message["591"]')
    },
    selectSearchPlace () {
      return this.$t('message["866"]')
    }
  },
  mounted () {
    this.initLoad()
  },
  methods: {
    ...mapActions('quit', ['getPeronListsDatas', 'getPeronsDatas', 'getMenuList']),
    ...mapMutations('quit', ['setquitName', 'setListShow', 'setQuitListDatas', 'setMenuList']),
    async initLoad () {
      if (this.userid !== 0) {
        const params = { 'userid': this.userid }
        // this.getPeronsDatas()
        // this._getPeronListsDatas(params)
        if (this.userid) {
          const obj = { userid: this.userid }
          const chain2 = await this.getMenuList()
          chain2.params(obj)
            .onSuccess(raw => {
              if (raw.length) {
                this._getPeronListsDatas(Object.assign(obj, { 'scope': raw[0].scope }))
                this.$emit('active', false, raw[0].scope)
              } else {
                this.$emit('active', true)
              }
            })
            .onNetSuccess(raw => {
              // this.isSubmiting = false
            })
            .fetch()
        }
        this.isSelected = true
        this.form.setFieldsValue(params)
        this.filterSetUser(this.userid)
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.isSubmiting = true
          // this._getPeronListsDatas(values)
          const chain = await this.getMenuList()
          chain.params(values)
            .onSuccess(raw => {
              if (raw.length) {
                this._getPeronListsDatas(Object.assign(values, { 'scope': raw[0].scope }))
                this.$emit('active', false, raw[0].scope)
              } else {
                this.$emit('active', true)
              }
            })
            .onNetSuccess(raw => {
              this.isSubmiting = false
            })
            .fetch()
        }
      })
    },
    async _getPeronListsDatas (values) {
      const chain = await this.getPeronListsDatas({ isFilter: false, isClue: values.scope === 'clue' })
      const _this = this
      chain.params(values)
        .onSuccess(raw => {
          // if (raw.data.list.length <= 0) {
          //   _this.$warning({
          //     type: 'warning',
          //     title: '信息提示',
          //     content: '暂无查询结果',
          //     iconType: 'check-circle',
          //     centered: true,
          //     closable: true
          //   })
          // } else {
          //   _this.setListShow(true)
          //   _this.$router.push({ path: _this.$route.path, query: values })
          // }
          _this.setListShow(true)
          _this.$router.push({ path: _this.$route.path, query: values })
        })
        .onNetSuccess(raw => {
          _this.isSubmiting = false
        })
        .fetch()
    },
    handleSelectChange (value) {
      this.isSelected = true
      this.setQuitListDatas({})
      this.filterSetUser(value)
      this.setMenuList([])
      this.$emit('active', false)
    },
    filterSetUser (userid) {
      for (let i = 0; i < this.personsList.length; i++) {
        let item = this.personsList[i]
        if (userid === item.userid) {
          this.setquitName(item)
          break
        }
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
<style lang="scss" scoped>
  .quit-select-form::v-deep {
    button[disabled] {
      border-color: #dbdbdb;
    }
  }
</style>
